module.exports = __webpack_public_path__ + "img/ph.e75d5f2f.png";